




























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class DraggableWidget extends Vue {
  @Prop({ required: true, type: String })
  private name!: string;
  @Prop({ required: true, type: Function })
  private render!: () => Promise<void>;
  @Prop({ required: false, type: Boolean, default: false })
  private showSettings!: boolean;

  private settingsEl = document.getElementById(this.settingsId);
  private contentEl = document.getElementById(this.contentId);

  get id() {
    return this.name;
  }
  get contentId() {
    return this.id + '-content';
  }
  get titleId() {
    return this.id + '-title';
  }
  get settingsId() {
    return this.id + '-settings';
  }

  private openSettings() {
    if (this.settingsEl) {
      this.settingsEl.classList.toggle('widget-hide');
    }
    if (this.contentEl) {
      this.contentEl.classList.toggle('widget-hide');
    }
  }

  private async mounted() {
    await this.render();
  }
}

Vue.component('DraggableWidget', DraggableWidget);
